import { cn } from '@utils/cn';

type ExternalLinkProps = {
  children: React.ReactNode;
  className?: string;
  href: string;
  target: string;
};

export function ExternalLink({ className, children, href, target }: ExternalLinkProps) {
  return (
    <a
      className={cn('underline', className)}
      href={href}
      target={target}
    >
      {children}
    </a>
  );
}
